import { LayoutClasses } from 'components/Layout';
import { useTranslation } from 'libs/i18n';
import { Button, Stack, Typography } from 'libs/ui';
import { GlobalStyles } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

import { ErrorLayoutStyled } from './ErrorLayout.styles';

export interface ErrorLayoutProps {
  title?: string;
  subtitle?: string;
  buttonLabel: string;
  onButtonClick: () => void;
}

export const ErrorLayout = ({
  buttonLabel,
  subtitle,
  title,
  onButtonClick,
}: ErrorLayoutProps) => {
  const { t } = useTranslation();

  return (
    <ErrorLayoutStyled alignItems="center" justifyContent="center">
      <GlobalStyles
        styles={{
          [`.${LayoutClasses.main}`]: {
            backgroundColor: `${Colors.gray50} !important`,
          },
        }}
      />
      <Stack alignItems="center" className="errorLayout-content" spacing={32}>
        <Stack alignItems="center" className="errorLayout-content" spacing={16}>
          <Typography align="center" variant="headerBold">
            {title ?? t('components.errorLayout.title')}
          </Typography>
          {!!subtitle && <Typography align="center">{subtitle}</Typography>}
        </Stack>
        <Button label={buttonLabel} onClick={onButtonClick} />
      </Stack>
    </ErrorLayoutStyled>
  );
};
